<div *ngIf="isLoading" class="text-center">
  <p-progressSpinner ariaLabel="loading" />
</div>
<div *ngIf="!isLoading">
  <div class="d-flex align-items-center my-4 p-0 go-back">
    <div (click)="goBack()">
      <i class="pi pi-arrow-left me-2 icon-list"> </i>
      <span class="label">Indietro</span>
    </div>
    <div class="hidden"></div>
    <div>
      <i
        title="Elimina bozza"
        class="pi pi-trash m-2 icon-list"
        (click)="onDelete()"
      ></i>
      <i
        title="Nuova riga"
        class="pi pi-plus icon m-2 icon-list"
        (click)="onCreateRow()"
      ></i>
      <i
        title="Aggiungi all'estratto conto"
        class="pi pi-file-plus m-2 icon-list"
        (click)="onAddRow()"
      ></i>

      <i
        title="Ricalcola"
        class="pi pi-calculator m-2 icon-list"
        (click)="onRecalculates()"
      ></i>
      <i
        title="Stampa PDF"
        class="pi pi-print m-2 icon-list"
        (click)="onStamp()"
      ></i>
      <i
        title="Esporta"
        class="pi pi-file-export m-2 icon-list"
        (click)="onStampRows()"
      ></i>
      <i
        title="Consolida e paga"
        class="pi pi-euro ms-2 icon-list"
        (click)="onOpenConsolidatesAndPay()"
      ></i>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6 col-md-12 d-flex align-items-center mb-3">
      <div class="label">Stato:</div>
      <div class="ms-2 value">
        {{ this.getState() }}
      </div>
    </div>
    <div
      class="col-lg-6 col-md-12 d-flex align-items-center mb-3"
      *ngIf="this.commissionService.isProducer"
    >
      <div class="label">Collaboratore:</div>
      <div class="ms-2 value">
        {{ this.bankRecordDetail?.collaboratorSurname }}
        {{ this.bankRecordDetail?.collaboratorName }}
      </div>
    </div>
    <div
      class="col-lg-6 col-md-12 d-flex align-items-center mb-3"
      *ngIf="!this.commissionService.isProducer"
    >
      <div class="label">Agenzia coassicuratrice:</div>
      <div class="ms-2 value">
        {{ this.bankRecordDetail?.desCoas }}
      </div>
    </div>
    <div class="col-lg-6 col-md-12 d-flex align-items-center mb-3">
      <div class="label">Estratto conto successivo:</div>
      <div class="ms-2 value">
        <a
          (click)="
            this.onClickLoadNewDetail(
              this.bankRecordDetail?.nextBankStatementId
            )
          "
          class="underline"
        >
          {{ this.bankRecordDetail?.nextBankStatementId }}</a
        >
      </div>
    </div>
    <div class="col-lg-6 col-md-12 d-flex align-items-center mb-3">
      <div class="label">Estratto conto precedente:</div>
      <div class="ms-2 value">
        <a
          (click)="
            this.onClickLoadNewDetail(
              this.bankRecordDetail?.prevBankStatementId
            )
          "
          class="underline"
        >
          {{ this.bankRecordDetail?.prevBankStatementId }}</a
        >
      </div>
    </div>
    <div class="col-lg-6 col-md-12 d-flex align-items-center mb-3">
      <div class="label">Premio lordo:</div>
      <div class="ms-2 value">
        {{ this.bankRecordDetail?.totStatementLordo ?? 0 | customCurrency }}
      </div>
    </div>
    <div class="col-lg-6 col-md-12 d-flex align-items-center mb-3">
      <div class="label">Premio netto:</div>
      <div class="ms-2 value">
        {{ this.bankRecordDetail?.totStatementNetto ?? 0 | customCurrency }}
      </div>
    </div>
    <div
      class="col-lg-6 col-md-12 d-flex align-items-center mb-3"
      *ngIf="this.commissionService.isProducer"
    >
      <div class="label">Provv. age.:</div>
      <div class="ms-2 value">
        {{ this.bankRecordDetail?.totProvvAge ?? 0 | customCurrency }}
      </div>
    </div>
    <div
      class="col-lg-6 col-md-12 d-flex align-items-center mb-3"
      *ngIf="this.commissionService.isProducer"
    >
      <div class="label">Tipo IFR:</div>
      <div class="ms-2 value">
        {{ this.bankRecordDetail?.IFRType?.type?.description }}
      </div>
    </div>
    <div
      class="col-lg-6 col-md-12 d-flex align-items-center mb-3"
      *ngIf="this.commissionService.isProducer"
    >
      <div class="label">Totale IFR Estratto Conto:</div>
      <div class="ms-2 value">
        {{ this.bankRecordDetail?.IFRType?.value ?? 0 | customCurrency }}
      </div>
    </div>
    <div
      class="col-lg-6 col-md-12 d-flex align-items-center mb-3"
      *ngIf="
        this.commissionService.isProducer &&
        this.bankRecordDetail?.IFRType?.type?.description === ifrTypes.differito
      "
    >
      <div class="label">Totale IFR accumulato:</div>
      <div class="ms-2 value">
        {{ this.bankRecordDetail?.totIFRAmassed ?? 0 | customCurrency }}
      </div>
    </div>
    <div class="col-lg-6 col-md-12 d-flex align-items-center mb-3">
      <div class="label">Totale ritenuta di acconto:</div>
      <div class="ms-2 value">
        {{ this.bankRecordDetail?.totWitholdingTax ?? 0 | customCurrency }}
      </div>
    </div>
    <div class="col-lg-6 col-md-12 d-flex align-items-center mb-3">
      <div class="label">Recupero sospesi al paga:</div>
      <div class="ms-2 value">
        {{ this.bankRecordDetail?.totRecuperoSosp ?? 0 | customCurrency }}
      </div>
    </div>
    <div class="col-lg-6 col-md-12 d-flex align-items-center mb-3">
      <div class="label">Totale pagato:</div>
      <div class="ms-2 value">
        {{ this.bankRecordDetail?.totGiven ?? 0 | customCurrency }}
      </div>
    </div>
    <div class="col-lg-6 col-md-12 d-flex align-items-center mb-3">
      <div class="label">Data inserimento:</div>
      <div class="ms-2 value">
        {{
          this.bankRecordDetail?.registrationDate
            | date : "dd/MM/yyyy HH:mm" : "UTC+1"
        }}
        {{ this.bankRecordDetail?.consolidatingUser }}
      </div>
    </div>
    <div class="col-lg-6 col-md-12 d-flex align-items-center mb-3">
      <div class="label">Data modifica:</div>
      <div class="ms-2 value">
        {{
          this.bankRecordDetail?.lastUpdateDate
            | date : "dd/MM/yyyy HH:mm" : "UTC+1"
        }}
        {{ this.bankRecordDetail?.lastUpdateUser }}
      </div>
    </div>
  </div>
  <hr class="my-4" />
  <p-table
    [tableStyle]="{ 'min-width': '50rem' }"
    [value]="recapValuesTable"
    styleClass="table-commission"
    dataKey="id"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Tipo Provvigione</th>
        <th>Dare</th>
        <th>Avere</th>
      </tr>
    </ng-template>

    <ng-template let-recap pTemplate="body">
      <tr
        [ngClass]="{
          'fw-bold':
            recap.key === 'Saldo Gestione Provvigionale' ||
            recap.key === 'Saldo'
        }"
        *ngIf="
          !(
            recap.key === 'Tot. IFR Immediato' &&
            this.bankRecordDetail?.IFRType?.type?.description === 'DIFFERITO'
          )
        "
      >
        <td>{{ recap.key }}</td>
        <td>{{ recap.value?.negativeSum ?? 0 | customCurrency }}</td>
        <td>{{ recap.value?.positiveSum ?? 0 | customCurrency }}</td>
      </tr>
    </ng-template>
  </p-table>
  <hr />
  <p-accordion [activeIndex]="0" styleClass="accordion">
    <p-accordionTab header="Righe estratto conto ({{ bankRows.length }})">
      <div>
        <p-table
          [value]="bankRows"
          dataKey="rowId"
          [scrollable]="true"
          [tableStyle]="{ 'min-width': '60rem' }"
          styleClass=" table-commission text-center"
          (onFilter)="onFilterTable($event)"
        >
          <ng-template pTemplate="header">
            <tr>
              <th
                *ngIf="commissionService.isProducer"
                pSortableColumn="codPdre"
                style="width: auto"
              >
                Codice produttore
                <p-sortIcon field="codPdre"></p-sortIcon>
              </th>
              <th
                *ngIf="!commissionService.isProducer"
                pSortableColumn="codCoas"
                style="width: auto"
              >
                Codice compagnia coassicuratrice
                <p-sortIcon field="codCoas"></p-sortIcon>
              </th>
              <th pSortableColumn="collectionDate" style="width: auto">
                Registrazione <p-sortIcon field="collectionDate"></p-sortIcon>
              </th>
              <th pSortableColumn="numPoli" style="width: auto">
                Polizza <p-sortIcon field="numPoli"></p-sortIcon>
              </th>
              <th pSortableColumn="fullName" style="width: auto">
                Cliente <p-sortIcon field="fullName"></p-sortIcon>
              </th>
              <th pSortableColumn="isCoass" style="width: auto">
                Coassicurazione
                <p-sortIcon field="isCoass"></p-sortIcon>
              </th>
              <th pSortableColumn="branch" style="width: auto">
                Ramo
                <p-sortIcon field="branch"></p-sortIcon>
              </th>
              <th pSortableColumn="reason" style="width: auto">
                Causale
                <p-sortIcon field="reason"></p-sortIcon>
              </th>
              <th pSortableColumn="gross" style="width: auto">
                Lordo
                <p-sortIcon field="gross"></p-sortIcon>
              </th>
              <th pSortableColumn="net" style="width: auto">
                Netto
                <p-sortIcon field="net"></p-sortIcon>
              </th>
              <th
                *ngIf="commissionService.isProducer"
                pSortableColumn="provvAgency"
                style="width: auto"
              >
                Provv. Age.
                <p-sortIcon field="provvAgency"></p-sortIcon>
              </th>
              <th
                *ngIf="commissionService.isProducer"
                pSortableColumn="provvCalcolata"
                style="width: auto"
              >
                Provv. Prod.
                <p-sortIcon field="provvCalcolata"></p-sortIcon>
              </th>
              <th *ngIf="!commissionService.isProducer" style="width: auto">
                Provv. Coass.
              </th>
              <th
                *ngIf="commissionService.isProducer"
                pSortableColumn="ifrImmediato"
                style="width: auto"
              >
                IFR immediato
                <p-sortIcon field="ifrImmediato"></p-sortIcon>
              </th>
              <th
                *ngIf="commissionService.isProducer"
                pSortableColumn="ifrDifferito"
                style="width: auto"
              >
                IFR differito
                <p-sortIcon field="ifrDifferito"></p-sortIcon>
              </th>
              <th pSortableColumn="totSospeso" style="width: auto">
                Sospeso
                <p-sortIcon field="totSospeso"></p-sortIcon>
              </th>
              <th pSortableColumn="manuallyUpdated" style="width: auto">
                Modifica manuale
                <p-sortIcon field="manuallyUpdated"></p-sortIcon>
              </th>
              <th pSortableColumn="manuallyCreated" style="width: auto">
                Creazione manuale
                <p-sortIcon field="manuallyCreated"></p-sortIcon>
              </th>
              <th></th>
            </tr>
            <tr>
              <th>
                <p-columnFilter
                  *ngIf="commissionService.isProducer"
                  field="codPdre"
                  matchMode="contains"
                  [showMenu]="false"
                >
                  <ng-template
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                  >
                    <input
                      type="text"
                      pInputText
                      [ngModel]="value"
                      (ngModelChange)="filter($event)"
                      class="p-inputtext"
                    />
                  </ng-template>
                </p-columnFilter>
                <p-columnFilter
                  *ngIf="!commissionService.isProducer"
                  field="codCoas"
                  matchMode="contains"
                  [showMenu]="false"
                >
                  <ng-template
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                  >
                    <input
                      type="text"
                      pInputText
                      [ngModel]="value"
                      (ngModelChange)="filter($event)"
                      class="p-inputtext"
                    />
                  </ng-template>
                </p-columnFilter>
              </th>
              <th>
                <p-columnFilter
                  field="formatedCollectionDate"
                  matchMode="contains"
                  [showMenu]="false"
                >
                  <ng-template
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                  >
                    <input
                      type="text"
                      pInputText
                      [ngModel]="value"
                      (ngModelChange)="filter($event)"
                      class="p-inputtext"
                    />
                  </ng-template>
                </p-columnFilter>
              </th>
              <th>
                <p-columnFilter
                  field="numPoli"
                  matchMode="contains"
                  [showMenu]="false"
                >
                  <ng-template
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                  >
                    <input
                      type="text"
                      pInputText
                      [ngModel]="value"
                      (ngModelChange)="filter($event)"
                      class="p-inputtext"
                    />
                  </ng-template>
                </p-columnFilter>
              </th>
              <th>
                <p-columnFilter
                  field="fullName"
                  matchMode="contains"
                  [showMenu]="false"
                >
                  <ng-template
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                  >
                    <input
                      type="text"
                      pInputText
                      [ngModel]="value"
                      (ngModelChange)="filter($event)"
                      class="p-inputtext"
                    />
                  </ng-template>
                </p-columnFilter>
              </th>
              <th></th>
              <th>
                <p-columnFilter
                  field="branch"
                  matchMode="contains"
                  [showMenu]="false"
                >
                  <ng-template
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                  >
                    <input
                      type="text"
                      pInputText
                      [ngModel]="value"
                      (ngModelChange)="filter($event)"
                      class="p-inputtext"
                    />
                  </ng-template>
                </p-columnFilter>
              </th>
              <th>
                <p-columnFilter
                  field="reason"
                  matchMode="contains"
                  [showMenu]="false"
                >
                  <ng-template
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                  >
                    <input
                      type="text"
                      pInputText
                      [ngModel]="value"
                      (ngModelChange)="filter($event)"
                      class="p-inputtext"
                    />
                  </ng-template>
                </p-columnFilter>
              </th>
              <th></th>
              <th></th>
              <th *ngIf="commissionService.isProducer"></th>
              <th *ngIf="commissionService.isProducer"></th>
              <th *ngIf="!commissionService.isProducer"></th>
              <th *ngIf="commissionService.isProducer"></th>
              <th *ngIf="commissionService.isProducer"></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-bankRecordRow let-i="rowIndex">
            <tr>
              <td class="text-center" *ngIf="commissionService.isProducer">
                {{ bankRecordRow.codPdre }}
              </td>
              <td class="text-center" *ngIf="!commissionService.isProducer">
                {{ bankRecordRow.codCoas }}
              </td>
              <td class="text-center">
                {{
                  bankRecordRow.collectionDate | date : "dd/MM/yyyy" : "UTC+1"
                }}
              </td>
              <td class="text-center">
                <a [href]="bankRecordRow?.policyLink" target="_blank">
                  {{ bankRecordRow?.numPoli }}</a
                >
                <span *ngIf="bankRecordRow.numMovi">
                  - {{ bankRecordRow?.numMovi }}</span
                >
              </td>
              <td class="text-center">
                {{ bankRecordRow.fullName }}
              </td>
              <td class="text-center">
                {{ bankRecordRow.isCoass ? "Si" : "No" }}
              </td>

              <td class="text-center">
                {{ bankRecordRow.branch ?? "" }}
              </td>

              <td class="text-center">
                {{ bankRecordRow.reason }}
              </td>
              <td class="text-center">
                {{ bankRecordRow.gross ?? 0 | customCurrency }}
              </td>
              <td class="text-center">
                {{ bankRecordRow.net ?? 0 | customCurrency }}
              </td>
              <td class="text-center" *ngIf="commissionService.isProducer">
                {{ bankRecordRow.provvAgency ?? 0 | customCurrency }}
              </td>
              <td class="text-center" *ngIf="commissionService.isProducer">
                {{ bankRecordRow.provvCalcolata ?? 0 | customCurrency }}
              </td>
              <td class="text-center" *ngIf="!commissionService.isProducer">
                {{ bankRecordRow.provvCalcolata ?? 0 | customCurrency }}
              </td>
              <td class="text-center" *ngIf="commissionService.isProducer">
                {{ bankRecordRow.ifrImmediato ?? 0 | customCurrency }}
              </td>
              <td class="text-center" *ngIf="commissionService.isProducer">
                {{ bankRecordRow.ifrDifferito ?? 0 | customCurrency }}
              </td>
              <td class="text-center">
                {{ bankRecordRow.totSospeso ?? 0 | customCurrency }}
              </td>

              <td>
                <div class="row text-center">
                  <div *ngIf="bankRecordRow.manuallyUpdated" class="col-md">
                    <p-image
                      src="../../../../../assets/images/touched.svg"
                      alt="Touched SVG"
                      title="Modifica manuale"
                      width="22"
                      class="ms-1"
                    ></p-image>
                  </div>
                </div>
              </td>
              <td>
                <div class="row text-center">
                  <div *ngIf="bankRecordRow.manuallyCreated" class="col-md">
                    <i
                      class="pi pi-user-edit icon-green"
                      title="Creata manualmente"
                    ></i>
                  </div>
                </div>
              </td>
              <td>
                <a
                  [href]="
                    onModifyRedirect(
                      bankRecordRow.rowId,
                      bankRecordRow.manuallyCreated
                    )
                  "
                  (click)="
                    onModify(
                      $event,
                      bankRecordRow.rowId,
                      bankRecordRow.manuallyCreated
                    )
                  "
                >
                  <i class="pi pi-pen-to-square icon" title="Modifica"></i>
                </a>
              </td>
            </tr>
          </ng-template>
        </p-table></div></p-accordionTab
  ></p-accordion>
</div>

<!-- Delete Modal-->
<div class="modal" tabindex="-1" id="deleteModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Attenzione</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <p>Confermi di voler eliminare la bozza?</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Annulla
        </button>
        <button
          type="button"
          class="btn btn-danger"
          (click)="deleteBankRecord()"
          data-bs-dismiss="modal"
        >
          Procedi
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Ricalculates Modal-->
<div class="modal" tabindex="-1" id="ricalculatesModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Attenzione</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <p>Confermi di voler Ricalcolare le righe?</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Annulla
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="recalculate()"
          data-bs-dismiss="modal"
        >
          Procedi
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Consolidate and pay Modal-->
<div class="modal" tabindex="-1" id="consolidateModal">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title label">Consolida e paga</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <p-table
          [tableStyle]="{ 'min-width': '50rem' }"
          [value]="recapValuesTable"
          styleClass="table-commission"
          dataKey="id"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Tipo Provvigione</th>
              <th>Dare</th>
              <th>Avere</th>
            </tr>
          </ng-template>

          <ng-template let-recap pTemplate="body">
            <tr>
              <td>{{ recap.key }}</td>
              <td>{{ recap.value?.negativeSum ?? 0 }}€</td>
              <td>{{ recap.value?.positiveSum ?? 0 }}€</td>
            </tr></ng-template
          >
        </p-table>
        <hr class="my-4" />
        <form
          [formGroup]="this.formRowsSosp"
          *ngIf="this.commissionService.isProducer"
        >
          <p-table
            [value]="this.getRows().controls"
            dataKey="value.rowId"
            [scrollable]="true"
            [(selection)]="selectedSposRows"
            [tableStyle]="{ 'min-width': '60rem' }"
            styleClass=" table-commission text-center"
          >
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 3rem"><p-tableHeaderCheckbox /></th>
                <th style="width: auto">Registrazione</th>
                <th style="width: auto">Polizza</th>
                <th style="width: auto">Cliente</th>
                <th style="width: auto">Lordo</th>
                <th style="width: auto">Sospeso</th>
                <th *ngIf="commissionService.isProducer" style="width: auto">
                  Codice produttore
                </th>
                <th *ngIf="!commissionService.isProducer" style="width: auto">
                  Codice compagnia coassicuratrice
                </th>
              </tr>
            </ng-template>
            <ng-template
              pTemplate="body"
              let-bankRecordRow
              let-rowIndex="rowIndex"
            >
              <tr>
                <td>
                  <p-tableCheckbox [value]="bankRecordRow" />
                </td>
                <td class="text-center">
                  {{
                    bankRecordRow.get("collectionDate").value
                      | date : "dd/MM/yyyy" : "UTC+1"
                  }}
                </td>
                <td class="text-center">
                  {{ bankRecordRow.get("numPoli").value }}
                </td>
                <td class="text-center">
                  {{ bankRecordRow.get("fullName").value }}
                </td>

                <td class="text-center">
                  {{ bankRecordRow.get("gross").value }}
                </td>

                <td class="text-center">
                  <div formArrayName="rows">
                    <div [formGroupName]="rowIndex">
                      <input
                        pInputText
                        id="totSospeso"
                        type="number"
                        formControlName="totSospeso"
                        [max]="this.bankRowsSosp[rowIndex].totSospeso"
                        placeholder="Inserisci"
                        class="commission-input my-2"
                        (click)="select(bankRecordRow)"
                      />
                    </div>
                  </div>
                </td>
                <td *ngIf="commissionService.isProducer" class="text-center">
                  {{ bankRecordRow.get("codPdre").value }}
                </td>
                <td *ngIf="!commissionService.isProducer">
                  {{ bankRecordRow.get("codCoas").value }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </form>
      </div>
      <div class="modal-footer center-footer-modal">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Annulla
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [attr.data-bs-dismiss]="this.formRowsSosp.valid ? 'modal' : ''"
          (click)="consolidateAndPay()"
        >
          Consolida
        </button>
      </div>
    </div>
  </div>
</div>
